module.exports = __webpack_public_path__ + "assets/img/whats.dd40ac1f.png";